import { TrainingClass } from './training.class';

export class TrainingEvent {
    ID: number;
    Created: Date;
    Modified: Date;
    EventDateTime: Date;
    TrainingClassID: number;
    TrainingClass: TrainingClass;

    // public static FixDates(item: TrainingEvent) {
    //     item.Created = new Date(item.Created);
    //     item.Modified = new Date(item.Modified);
    //     item.EventDateTime = new Date(item.EventDateTime);
    // }

}

export class TrainingEventArray extends Array<TrainingEvent> {

    constructor(...items: TrainingEvent[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingEventArray.prototype);
    }

    public static FixDates(item: TrainingEventArray) {
        //item.forEach(x => TrainingEvent.FixDates(x));
    }


}
